<template>
  <HomeCard more_url="/flash-sales?source=homePage|flashSale|">
    <template #header>
      <div @click="actFlashFn" class="flash-header">
        <div class="flash-icon">
          <img v-webp src="https://image.kilimall.com/kenya/new_wap/userCenter/ic_flash_sale.png" />
        </div>
        <div class="flash-info">
          <div>{{ statusText }}</div>
          <van-count-down :time="time_mm">
            <template #default="timeData">
              <div class="flash-date">
                <span>{{ format_time_fn(timeData.hours) }}</span>:
                <span>{{ format_time_fn(timeData.minutes) }}</span>:
                <span>{{ format_time_fn(timeData.seconds) }}</span>
              </div>
            </template>
          </van-count-down>
        </div>
      </div>
    </template>
    <template #content>
      <KProductList type="flash-sale" :product-list="previewSkus" />
    </template>
  </HomeCard>
</template>
<script setup lang="ts">
const emits = defineEmits<{
  (e: 'no-data'): void
}>()

/** 获取秒杀文案， 未开始还是结束 */
const time_mm = ref<number>(0) // 倒计时毫秒
const statusText = ref<string>('Starting in')
const time_type_name = (session: any) => {
  const { status, startTime, endTime } = session
  if(!startTime || !endTime){
    return 0
  }
  
  if (status === 1) {
    // 已开始
    time_mm.value = new Date(endTime).getTime() - new Date().getTime()
    statusText.value = 'Ends in'
  } else {
    // 未开始
    time_mm.value = new Date(startTime).getTime() - new Date().getTime()
    
    statusText.value = 'Starting in'
  }
}
const format_time_fn = (time: number | string) => {
  if(Number(time) < 10) {
    return  '0' + time.toString()
  }
  return time
}


const previewSkus = ref<IFlashSaleSku[]>([])

const { skus, session } = useGlobalJsonData().value.flashsale.data
if(skus.length <= 0) {
  emits('no-data')
} else {
  time_type_name(session)
  previewSkus.value = (skus || []).slice(0, 5)
}

// const previewSkus = ref<IFlashSaleSku[]>(
//   new Array(4).fill({
//     index: 0,
//     image: "",
//     activityPrice: 0,
//     title: "",
//     listPrice: 0,
//     skuId: -1,
//     storeName: ""
//   })
// )
// onMounted(async () => {
//   const flashSale = await initFlashSaleByCache()
  
//   // 1 进行中  3 未开始  4  已过期
//   let data = flashSale.find((c: any) => c.session.status === 1)
//   if(!data) {
//     data = flashSale.find((c: any) => c.session.status === 3)
//   }
  
//   if(!data?.skus.length) {
//     emits('no-data')
//     return
//   }
//   const { skus, session } = data
  
//   time_type_name(session)
//   previewSkus.value = skus || []
// })

const actFlashFn = () => {
  useRouter().push('/flash-sales?source=homePage|mainIcon|flashSale')
}
</script>
<style lang='scss' scoped>
.flash-header {
  height: 100%;
  width: 100%;
  display: flex;
  .flash-icon {
    height: 90px;
    line-height: 90px;
    display: flex;
    align-items: center;
    img {
      height: 50%;
    }
  }
  .flash-info {
    color: var(--font_color_02);
    font-size: 24px;
    width: 300px;
    flex: 1;
    display: flex;
    text-align: right;
    justify-content: flex-end;
    align-items: center;
    
    .flash-date {
      margin-left: 10px;
      display: flex;
      align-items: center;
      span {
        background-color: var(--default_font_color);
        color: white;
        width: 40px;
        height: 36px;
        text-align: center;
        line-height: 36px;
        display: inline-block;
        font-size: 28px;
        margin: 0 2px;
        border-radius: 4px;
        overflow: hidden;
      }
    }
  }
}
</style>